import useEmblaCarousel from 'embla-carousel-react';
import React, { useCallback } from 'react';

import { Button } from '@/components/ui/button';
import { useLocale } from '@/contexts/LocaleContext';
import { getDictionary } from '@/utils/getDictionary';

import styles from './Slider.module.scss';

export const SliderControls: React.FC<{
  canScrollPrev: boolean;
  canScrollNext: boolean;
  showListControlsText?: boolean;
  childrenCount: number;
  activeIndex: number;
  emblaApi: ReturnType<typeof useEmblaCarousel>[1];
}> = ({
  activeIndex,
  canScrollNext,
  canScrollPrev,
  childrenCount,
  emblaApi,
  showListControlsText,
}) => {
  const locale = useLocale();
  const t = getDictionary(locale);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <div className={styles.listControls}>
      <Button
        className='button button--level-2 button--icon'
        disabled={!canScrollPrev}
        onClick={scrollPrev}
        aria-label={t('previous')}
      >
        <span className={styles.icon}>
          <svg
            width='14'
            height='15'
            viewBox='0 0 14 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M9.05988 11.93C9.10052 11.9706 9.13277 12.0189 9.15477 12.072C9.17676 12.1251 9.18809 12.182 9.18809 12.2395C9.18809 12.297 9.17676 12.3539 9.15477 12.407C9.13277 12.4601 9.10052 12.5084 9.05988 12.549C9.01923 12.5897 8.97097 12.6219 8.91786 12.6439C8.86475 12.6659 8.80783 12.6772 8.75034 12.6772C8.69286 12.6772 8.63594 12.6659 8.58283 12.6439C8.52972 12.6219 8.48146 12.5897 8.44081 12.549L4.06581 8.17403C4.02514 8.1334 3.99287 8.08515 3.97085 8.03204C3.94883 7.97893 3.9375 7.922 3.9375 7.8645C3.9375 7.80701 3.94883 7.75008 3.97085 7.69696C3.99287 7.64385 4.02514 7.5956 4.06581 7.55497L8.44081 3.17997C8.52291 3.09788 8.63425 3.05176 8.75034 3.05176C8.86644 3.05176 8.97778 3.09788 9.05988 3.17997C9.14197 3.26206 9.18809 3.3734 9.18809 3.4895C9.18809 3.6056 9.14197 3.71694 9.05988 3.79903L4.99386 7.8645L9.05988 11.93Z' />
          </svg>
        </span>
      </Button>
      {showListControlsText && (
        <span className={styles.total}>{`${activeIndex + 1} ${t('of')} ${
          childrenCount
        }`}</span>
      )}
      <Button
        className='button button--level-2 button--icon'
        onClick={scrollNext}
        disabled={!canScrollNext}
        aria-label={t('next')}
      >
        <span className={styles.icon}>
          <svg
            width='14'
            height='15'
            viewBox='0 0 14 15'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M9.93477 8.17403L5.55977 12.549C5.51913 12.5897 5.47087 12.6219 5.41776 12.6439C5.36465 12.6659 5.30773 12.6772 5.25024 12.6772C5.19276 12.6772 5.13584 12.6659 5.08273 12.6439C5.02962 12.6219 4.98136 12.5897 4.94071 12.549C4.90006 12.5084 4.86782 12.4601 4.84582 12.407C4.82382 12.3539 4.8125 12.297 4.8125 12.2395C4.8125 12.182 4.82382 12.1251 4.84582 12.072C4.86782 12.0189 4.90006 11.9706 4.94071 11.93L9.00673 7.8645L4.94071 3.79903C4.85862 3.71694 4.8125 3.6056 4.8125 3.4895C4.8125 3.3734 4.85862 3.26206 4.94071 3.17997C5.0228 3.09788 5.13415 3.05176 5.25024 3.05176C5.36634 3.05176 5.47768 3.09788 5.55977 3.17997L9.93477 7.55497C9.97545 7.5956 10.0077 7.64385 10.0297 7.69696C10.0518 7.75008 10.0631 7.80701 10.0631 7.8645C10.0631 7.922 10.0518 7.97893 10.0297 8.03204C10.0077 8.08515 9.97545 8.1334 9.93477 8.17403Z' />
          </svg>
        </span>
      </Button>
    </div>
  );
};
